export const roleConfigs = {
  company: { title: "Company Admin", home: "/CompanyDashBord", inventory: "/Comasset", register: "/ComapnyAssetRegister", pending: "/ComPendingAsset", users: "/CompanyUsers", addUser: "/companyUserRole", distribution: "department", distributionLabel: "departments", scope: "company" },
  department: { title: "Department Admin", home: "/DepartmentDashBoard", inventory: "/DepartmentAssetDetails", register: "/DepartmentAssetRegister", pending: "/DepPendingAsset", users: "/DepartmentUserDetails", addUser: "/departmentAddUser", distribution: "type", distributionLabel: "asset types", scope: "department" },
  audit: { title: "Audit", home: "/AuditDashBoard", inventory: "/AuditAsset", register: "/AuditAssetRegister", pending: "/PendingAllAsset", verify: "/PendingAsset", discard: "/PendingDiscardItem", report: "/AssetReport", transferReport: "/AssetTranfer", distribution: "company", distributionLabel: "companies", scope: "group" },
  other: { title: "Other User", home: "/OtherUserDashBoard", inventory: "/OtherUserAssetDetails", register: "/OtherUserAssetRegister", pending: "/OtherUserPendingAssetDetails", distribution: "type", distributionLabel: "asset types", scope: "department" },
};

export function canVerify(role, profile) {
  return role === "department" && ["Account", "Audit"].includes(profile?.department);
}

export function scopeRecords(records, config, profile, userRecords = false) {
  if (!Array.isArray(records)) return null;
  if (config.scope === "group") return records;
  if (!profile?.companyName || (config.scope === "department" && !profile.department)) return null;
  return records.filter(record =>
    record[userRecords ? "companyName" : "company"] === profile.companyName &&
    (config.scope !== "department" || record.department === profile.department)
  );
}

export function roleNavigation(role, profile) {
  const config = roleConfigs[role];
  const workspace = [
    [config.home, "Dashboard", "chart-pie"],
    [config.inventory, "Asset Details", "layer-group"],
    [config.register, "Asset Registration", "circle-plus"],
  ];
  if (role === "department") workspace.push(["/OtherDepartmentAsset", "Category Asset", "shapes"]);
  const operations = [[config.pending, "Pending Asset", "clock"]];
  if (canVerify(role, profile)) operations.push(["/AssetVerification", "Asset Verification", "circle-check"]);
  if (role === "audit") operations.push([config.verify, "Verify Asset", "circle-check"], [config.discard, "Discard Asset", "trash-can"]);
  const management = config.users ? [[config.users, "Users", "users"], [config.addUser, "Add Users Role", "user-plus"]] : [];
  if (role === "audit") management.push([config.report, "Asset Report", "chart-column"], [config.transferReport, "Transfer Report", "file-lines"]);
  return [["WORKSPACE", workspace], ["OPERATIONS", operations], ...(management.length ? [["MANAGEMENT", management]] : [])];
}

export function dashboardCards(role, data, profile) {
  const config = roleConfigs[role];
  const { assets, users, pending, transfers, discarded, verification } = data;
  const countRole = key => users ? users.filter(user => user.selectedOption === key).length : null;
  const cards = [
    ["Registered assets", assets?.length, "layer-group", config.inventory, "Within your workspace", "teal"],
    ["Pending registration", pending?.length, "clock", config.pending, "Awaiting approval", "amber"],
  ];
  if (role === "company") {
    cards.splice(1, 0, ["Company users", countRole("CompanyAdmin"), "users", config.users, "Company administrators", "sage"]);
    cards.push(["Department users", countRole("DepartmentAdmin"), "users", config.users, "Department administrators", "blue"],
      ["Other users", countRole("OtherUser"), "user", config.users, "Across your company", "sage"]);
  }
  if (role === "department") {
    cards.splice(1, 0, ["Department users", countRole("DepartmentAdmin"), "users", config.users, "Your department administrators", "sage"]);
    cards.push(["Other users", countRole("OtherUser"), "user", config.users, "Within your department", "blue"]);
    if (canVerify(role, profile)) cards.push(["Pending verification", verification?.length, "circle-check", "/AssetVerification", "Across your company", "teal"]);
  }
  if (role === "audit") {
    cards[1][0] = "Pending verification";
    cards[1][3] = config.verify;
    cards.push(["Pending transfers", transfers?.length, "arrow-right-arrow-left", config.verify, "Awaiting verification", "sage"],
      ["Pending disposal", discarded?.length, "trash-can", config.discard, "Awaiting review", "blue"]);
  }
  return cards;
}
